import React from 'react';

//image
import defaultPng from '../../../../images/default.png'

//functions
import { makeMeMember, makeMeAdmin} from './functions/ChangeRoles';

export default function Roles({adminRole, profile}) {
  return (
    <div>
    <h2 className="mb-2 text-gray-500 text-xs font-medium uppercase tracking-wide">Roles</h2>
    <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {adminRole?.map((person) => (
        <li key={person.email} className="col-span-1 bg-white rounded-lg ">
          <div className="w-full flex items-center justify-between p-6 space-x-6">
            <div className="flex-1 truncate">
              <div className="flex items-center space-x-3">
                <h3 className="text-gray-900 text-sm font-medium truncate">{person.firstName} {person.lastName}</h3>
                {(person.role === 'member') ?
                <span className="flex-shrink-0 inline-block px-2 py-0.5 text-red-800 text-xs font-medium bg-red-100 rounded-full">
                Member
                </span>
                :
                <span className="flex-shrink-0 inline-block px-2 py-0.5 text-green-800 text-xs font-medium bg-green-100 rounded-full">
                  Admin
                </span>
                }
              </div>
              <p className="mt-1 text-gray-500 text-sm truncate">{person.company}</p>
              {person?.master ?
                <span className="flex-shrink-0 inline-block px-2 my-2 py-0.5 text-red-800 text-xs font-medium bg-red-100 rounded-full">
                    Head Admin
                </span>
              :
                null
              }
            </div>
            <img className="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0" src={defaultPng} alt="personPng" />
          </div>
          <div>
            <div className="-mt-px flex divide-x divide-gray-200">
              <div className="w-0 flex-1 flex">
                {!person?.master ?
                    <p className="m-2 my-4 relative z-0 inline-flex shadow-sm rounded-md">
                        {/* <span className="mt-1">Change role in organization </span> */}
                    {(person?.role === 'admin') ? 
                        <button
                            type="button"
                            className="ml-1 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            onClick={()=>makeMeMember(profile.company, person.id)}
                        >
                            Make A Member
                        </button>
                    :
                        <button
                            type="button"
                            className="ml-1 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            onClick={()=>makeMeAdmin(profile.company, person.id)}
                        >
                            Make An Admin
                        </button>
                    }
                    </p>
                :
                    null
                }
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
    </div>
  )
}